// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NewsletterSection-Form{max-width:950px;padding-left:var(--layout-lateral);padding-right:var(--layout-lateral);margin:0 auto}.NewsletterSection .Image{width:auto;height:auto;display:block;text-align:center;margin-bottom:15px}.NewsletterSection .Image img{width:auto !important;position:static}\n", ""]);
// Exports
module.exports = exports;
